function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { Controller } from 'stimulus';
import Rails from '@rails/ujs';
import debounce from 'lodash.debounce';
/**
 * Stimulus integration with Rails UJS. Use this controller to handle HTML
 * rendered responses from rails controllers.
 * @extends Controller
 */

var RemoteController = /*#__PURE__*/function (_Controller) {
  _inherits(RemoteController, _Controller);

  var _super = _createSuper(RemoteController);

  function RemoteController() {
    _classCallCheck(this, RemoteController);

    return _super.apply(this, arguments);
  }

  _createClass(RemoteController, [{
    key: "connect",
    value: function connect() {
      this.debounceTime = parseInt(this.data.get('debounceTime') || 300);
      this.debouncedSubmit = debounce(this.submit, this.debounceTime);
    }
    /**
     * Submits a Rails remote form
     * @param {Event} event - an event with a currentTarget DOMElement
     */

  }, {
    key: "submit",
    value: function submit(event) {
      Rails.fire(event.target.form, 'submit');
    }
    /**
     * Appends the HTML Fragment from the response to the response target
     * @param {Event} event - a Rails UJS response event
     */

  }, {
    key: "append",
    value: function append(event) {
      var _this = this;

      this._handleResponse(event, function (fragment) {
        _this._responseTarget(event).append(fragment);
      });
    }
    /**
     * Prepends the HTML Fragment from the response to the response target
     * @param {Event} event - a Rails UJS response event
     */

  }, {
    key: "prepend",
    value: function prepend(event) {
      var _this2 = this;

      this._handleResponse(event, function (fragment) {
        _this2._responseTarget(event).prepend(fragment);
      });
    }
    /**
     * Replaces the response target with the HTML Fragment from the response
     * @param {Event} event - a Rails UJS response event
     */

  }, {
    key: "replace",
    value: function replace(event) {
      var _this3 = this;

      this._handleResponse(event, function (fragment) {
        _this3._responseTarget(event).replaceWith(fragment);
      });
    }
    /**
     * Replaces the inside of the response target with the HTML Fragment from the response
     * @param {Event} event - a Rails UJS response event
     */

  }, {
    key: "replaceInner",
    value: function replaceInner(event) {
      var _this4 = this;

      this._handleResponse(event, function (fragment) {
        var responseTarget = _this4._responseTarget(event);

        responseTarget.innerHTML = '';
        responseTarget.appendChild(fragment);
      });
    }
    /**
     * Removes the response target
     * @param {Event} event - a Rails UJS response event
     */

  }, {
    key: "remove",
    value: function remove(event) {
      var _this5 = this;

      this._handleResponse(event, function (fragment) {
        _this5._responseTarget(event).remove();
      });
    } // Private methods

    /**
     *
     * @param {Event} event - a Rails UJS response event
     * @param {Function} callback - a function taking a fragment parameter
     */

  }, {
    key: "_handleResponse",
    value: function _handleResponse(event, callback) {
      var _event$detail = _slicedToArray(event.detail, 3),
          xhr = _event$detail[2];

      var fragment = this._documentFragment(xhr.response);

      this._processScripts(fragment);

      callback(fragment);
    }
    /**
     * @private
     * @param {(string|DocumentFragment)} data
     * @returns DocumentFragment
     */

  }, {
    key: "_documentFragment",
    value: function _documentFragment(data) {
      var el = document.createElement('template');
      el.innerHTML = data;
      return el.content;
    }
    /**
     * @private
     * @param {NodeList} scripts
     */

  }, {
    key: "_processScripts",
    value: function _processScripts(fragment) {
      if (!this.data.has('loadScripts')) return;

      var _iterator = _createForOfIteratorHelper(fragment.querySelectorAll('script')),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var script = _step.value;
          eval(script.innerHTML);
        } // eslint-disable-line no-eval

      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "_responseTarget",
    value: function _responseTarget(event) {
      var responseTarget = this.element;

      if (this.data.has('responseTarget')) {
        var targetString = this.data.get('responseTarget');

        try {
          var object = JSON.parse(targetString);

          if (object[event.type] !== undefined) {
            responseTarget = document.querySelector(object[event.type]);
          }
        } catch (_unused) {
          responseTarget = document.querySelector(targetString);
        }
      }

      return responseTarget;
    }
  }]);

  return RemoteController;
}(Controller);

export { RemoteController as default };
export { RemoteController };